import { Button, DataSource, Layout, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderPayablesGroupByTable extends Layout {
    buttonClearSelections: Button;
    sourceOrderPayablesCache: DataSource;
    tableGroupBy: Table;
    textboxGroupBy: Textbox;
    textboxTotal: Textbox;
}
